import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import Print from '@/utils/print'

import './nycClient.js';

import '@/assets/element/index.scss'
import i18n from './i18n'

const app = createApp(App)

app.config.errorHandler = (err, instance, info) => {
  console.log(err, instance, info);
}

// 自定义指令
// 设置el-table的height,在父标签加上v-height
app.directive('height', (el, binding) => {
  // binding.value = margin的值,用户手动输入
  var form = el.querySelector('.td');
  var page = el.querySelector('.page');
  var summary = el.querySelector('.summary');
  var tabPage = el.querySelector('.tabPage');
  var h = 0;
  if(form) h += form.offsetHeight;
  if(page) h += page.offsetHeight;
  if(summary) h += summary.offsetHeight;
  if(tabPage) h += tabPage.offsetHeight;
  if(binding.value) h += binding.value;
  if(el.getElementsByClassName('table')[0]){
    el.getElementsByClassName('table')[0].setAttribute('style', `height: calc(100% - ${h}px)`)
  }
})
//防止重复点击
app.directive('reClick', (el, binding) => {
  el.addEventListener('click', () => {
    if (!el.disabled) {
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
      }, binding.value || 3000)
    }
  })
})

// webSocket
import socket from '@/utils/websocket.js'
// console.log(socket);
app.config.globalProperties.$socket = socket;
// 连接webSocket
socket.global_websocket_connect();
// webSocket end

app.use(createPinia())
app.use(router)
app.use(Print)
app.use(i18n)
app.mount('#app')
